/** 자재품종에서 성적서 분석의 두께로 쓰는 칸. 코드 또는 이름 관례다. */
export const thicknessDetailsOf = (slot) => (slot?.details || []).filter((detail) => {
  const code = String(detail?.gcomponentCode || '').toUpperCase();
  const name = String(detail?.gcomponentName || '');
  return code.includes('THICKNESS') || name.includes('두께');
});

const hasKey = (leadKeys, key) => (leadKeys || []).includes(key);

/**
 * 분석 화면에 올릴 칸.
 * 유리 구성, 자재품종 두께, 두께 입력은 함께 나오지 않는다.
 * 등급은 그 칸과 같이 나올 수 있다.
 */
export const planComparisonLeadForm = ({ leadKeys = [], division, slot, gradeCount = 0 } = {}) => {
  const process = division === 'PROCESS';
  const needsThickness = hasKey(leadKeys, 'thickness') || hasKey(leadKeys, 'ft_thick_class');
  const needsKs = hasKey(leadKeys, 'ks2004_thickness');
  const needsGrade = hasKey(leadKeys, 'classification') || hasKey(leadKeys, 'ft_thick_class');
  const thicknessDetails = thicknessDetailsOf(slot);
  const notices = [];
  let showGlass = false;
  let showSlot = false;
  let showPlain = false;
  let showGrade = false;

  if (process && (needsThickness || needsKs)) {
    showGlass = true;
  }
  if (!process && needsKs) {
    notices.push('가공이 아닌 인증규격에는 접합 층 두께를 만들 유리 구성이 없습니다.');
  }
  if (!process && needsThickness) {
    if (slot && thicknessDetails.length === 1) showSlot = true;
    else if (slot && thicknessDetails.length > 1) {
      notices.push('자재품종에 두께 칸이 여러 개라 어느 칸을 쓸지 정해져 있지 않습니다.');
    } else if (slot) {
      notices.push('자재품종에서 두께 칸을 찾지 못했습니다.');
    } else {
      showPlain = true;
    }
  }
  if (needsGrade && gradeCount > 0) showGrade = true;
  else if (needsGrade && hasKey(leadKeys, 'ft_thick_class')) {
    notices.push('등급 목록이 없어 두께와 등급을 붙일 수 없습니다.');
  }

  return {
    showGlass, showSlot, showPlain, showGrade, thicknessDetails, notices,
  };
};

/** 제품명만 있는 폴더와 자재품종 배열 속성은 두께·등급을 그대로 저장하지 못한다. */
export const specAcceptsAnalysisFields = (spec, division) => {
  if (!spec?.g04docuGCertificationId) return false;
  if (division === 'PROCESS') return true;
  if (spec.productName && !spec.productFolderId) return false;
  if (Array.isArray(spec.materialSlotValues) && spec.materialSlotValues.length && !spec.productFolderId) {
    return false;
  }
  return true;
};
